import { render, staticRenderFns } from "./Inspektionen.vue?vue&type=template&id=7f0fb47a&scoped=true&"
import script from "./Inspektionen.vue?vue&type=script&lang=js&"
export * from "./Inspektionen.vue?vue&type=script&lang=js&"
import style0 from "./Inspektionen.vue?vue&type=style&index=0&id=7f0fb47a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0fb47a",
  null
  
)

export default component.exports